import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

function isHeading(line) {
  const keywords = ['Basic', 'Neutral', 'Professional', 'Polished'];
  const lower = line.toLowerCase();
  return keywords.some(k => lower.includes(k.toLowerCase()));
}

const renderLines = (lines, align = 'left') => (
  <Box sx={{ whiteSpace: 'pre-line', textAlign: align }}>
    {lines.map((line, idx) => {
      const heading = isHeading(line);
      return (
        <Typography
          key={idx}
          variant={heading ? 'subtitle1' : 'h6'}
          sx={{
            color: heading ? 'black' : 'white',
            textDecoration: heading ? 'underline' : 'none',
            lineHeight: heading ? 1.3 : 1.4,
          }}
        >
          {line}
        </Typography>
      );
    })}
  </Box>
);

// Dual-mode component:
// 1) Card preview for FlashcardsManager: pass `card`
// 2) Modal preview for builder: pass `open`, `flashcards` (array), and `title`
export default function FlashcardPreview({ card, open = false, onClose, flashcards = [], title = 'Flashcards' }) {
  // Card mode
  if (card) {
    const linesA = (card.side_a || '').split(/\r?\n/);
    const linesB = (card.side_b || '').split(/\r?\n/);
    return (
      <Box sx={{ display: 'flex', gap: 2, p: 2, bgcolor: '#53267f', borderRadius: 2 }}>
        <Box sx={{ flex: 1 }}>{renderLines(linesA, 'left')}</Box>
        <Box sx={{ flex: 1, bgcolor: '#9c1748', borderRadius: 2 }}>{renderLines(linesB, 'left')}</Box>
      </Box>
    );
  }

  // Modal mode
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {flashcards.length === 0 ? (
            <Typography variant="body2" color="text.secondary">No flashcards to preview.</Typography>
          ) : (
            flashcards.map((fc, idx) => {
              const linesA = (fc.side_a || '').split(/\r?\n/);
              const linesB = (fc.side_b || '').split(/\r?\n/);
              return (
                <Box key={idx} sx={{ display: 'flex', gap: 2, p: 2, bgcolor: '#53267f', borderRadius: 2 }}>
                  <Box sx={{ flex: 1 }}>{renderLines(linesA, 'left')}</Box>
                  <Box sx={{ flex: 1, bgcolor: '#9c1748', borderRadius: 2 }}>{renderLines(linesB, 'left')}</Box>
                </Box>
              );
            })
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
